import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '@core/config/config.service';
import { AuthService } from '@core/guards/auth.service';
import { HttpService } from '@core/http/http.service';
import { WorkflowModel } from '@core/models/workflows/workflow.model';
import { WorkflowDetailModel } from '@core/models/workflows/workflow-detail.model';
import { ImportReportModel } from '@core/models/administration/imports/import-report.model';


@Injectable({
  providedIn: 'root'
})
export class WorkflowService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'workflows');
  }

  getWorkflows(): Observable<WorkflowModel[]> {
    return this.invokeGet<WorkflowModel[]>();
  }

  getWorkflowDetailById(workflowId: number): Observable<WorkflowDetailModel> {
    return this.invokeGet<WorkflowDetailModel>(`${workflowId}/detail`);
  }

  getOperationalGroupWorkflows(operationalGroupId: number): Observable<WorkflowModel[]> {
    return this.invokeGet<WorkflowModel[]>(`group/${operationalGroupId}`);
  }

  deactivateWorkflow(workflowId: number): Observable<any> {
    return this.invokePut(null, `${workflowId}/deactivate`);
  }

  activateWorkflow(workflowId: number): Observable<any> {
    return this.invokePut(null, `${workflowId}/activate`);
  }

  createWorkflow(workflow: WorkflowDetailModel): Observable<any> {
    return this.invokePost(workflow);
  }

  updateWorkflow(workflow: WorkflowDetailModel): Observable<any> {
    return this.invokePut(workflow);
  }

  importWorkflow(files: File[]): Observable<ImportReportModel[]> {
    return this.invokeUploadFiles(files, `import`);
  }
}
